import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { rockerboxEmployerKey } from '../constants';
import { getRockerboxEmployerRoute } from '../api/constant';
import { errorMessage } from '@features/applications';


type useGetRockerboxEmployerProps = {
    id: string | number | undefined;
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetRockerboxEmployer = ({
    id,
    setErrorText = () => { },
}: useGetRockerboxEmployerProps) => {
    const {
        data: employerData,
        isFetching: isLoadingEmployerData,
    }: UseQueryResult<any, any> = useQuery({
        queryKey: [rockerboxEmployerKey, id],
        queryFn: () =>
            axiosInstance
                .get(getRockerboxEmployerRoute, { params: { employer_id: id } })
                .then((res) => res.data),
        enabled: !!id,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            if (data.status === 200) {
                // setSelectedEvent(data.object);
                setErrorText('');
            } else {
                setErrorText(data.message);
            }
        },
        onError: (data) => {
            setErrorText(data.message);
        },
    });

    return {
        employerData,
        isLoadingEmployerData,
    };
};
